import { toast } from "@performyard/py-components";

export function DisplayError(message) {
	return () => {
		toast.error(message);
	};
}

export const displayWarning = (message) => () => {
	toast.warning(message);
};

export function DisplaySuccess(message) {
	return () => {
		toast.success(message);
	};
}

export function DisplayCheckbox(time = 1000) {
	return () => {
		/*
            This is the old checkbox success notification.
        */

		if (window.Success) {
			window.Success({ time });
		}
	};
}
